import React from "react";
import ButtonOption from "../conv-message/button-option";
import ImageMessage from "../conv-message/image-message";

import AuthLoginMessage from "../conv-message/auth-login-message";
import TextMessage from "../conv-message/text-message/text-message";
import CardList from "../conv-message/cards";
import Buttons from "../conv-message/buttons";
import DocCapture from "../conv-message/doc-capture";
import PaginatedMessage from "../conv-message/paginated-message";

export default function BotMessageFactory(props) {
  const { type } = props;
  let comp;
  if (type === "TEXT") {
    comp = <TextMessage {...props} />;
  } else if (type === "CARDS") {
    comp = <CardList {...props} />;
  } else if (type === "BUTTONS") {
    comp = <Buttons {...props} />;
  } else if (type === "BUTTON_TEXT") {
    comp = <ButtonOption {...props} />;
  } else if (type === "DOC_CAPTURE") {
    comp = <DocCapture {...props} />;
  } else if (type === "IMAGE") {
    comp = <ImageMessage {...props} />;
  } else if (type === "PAGINATED") {
    comp = <PaginatedMessage {...props} />;
  } else if (type === "AUTH") {
    comp = <AuthLoginMessage {...props} />;
  } else {
    comp = <pre>{JSON.stringify(props.message, null, 2)}</pre>;
  }
  return comp;
}
